import React, { useState, useEffect } from 'react';
import WidgetWrapper from './WidgetWrapper';

const ShellyWidget = ({ darkMode = false, onError }) => {
  const [shellyData, setShellyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const shellyRes = await fetch('/api/shelly');
        const shelly = await shellyRes.json();
        setShellyData(shelly);
      } catch (shellyErr) {
        console.error('ShellyWidget error:', shellyErr);
        onError?.('ShellyWidget', shellyErr.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [onError]);

  const subTextColor = darkMode ? '#9ca3af' : '#6b7280';

  return (
    <WidgetWrapper title="🌡️ Datacenter Temp" loading={loading} darkMode={darkMode}>
      {!shellyData ? (
        <p style={{ color: subTextColor, textAlign: "center", padding: 20 }}>Loading...</p>
      ) : (
        <div style={{ display: 'flex', gap: 12, marginBottom: 12 }}>
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 28, fontWeight: 'bold', color: '#3b82f6' }}>{shellyData.temperature}°C</div>
            <div style={{ fontSize: 12, color: subTextColor }}>{shellyData.temperatureF}°F</div>
          </div>
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 'bold', color: '#06b6d4' }}>{shellyData.humidity}%</div>
            <div style={{ fontSize: 12, color: subTextColor }}>Humidity</div>
          </div>
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 'bold', color: shellyData.battery < 20 ? '#ef4444' : shellyData.battery < 50 ? '#f59e0b' : '#22c55e' }}>
              {shellyData.battery}%
            </div>
            <div style={{ fontSize: 12, color: subTextColor }}>Battery</div>
          </div>
          <div style={{ textAlign: 'center', flex: 1 }}>
            <div style={{ fontSize: 20, fontWeight: 'bold', color: shellyData.online ? '#22c55e' : '#ef4444' }}>
              {shellyData.online ? '✓' : '✗'}
            </div>
            <div style={{ fontSize: 12, color: subTextColor }}>Online</div>
          </div>
        </div>
      )}
    </WidgetWrapper>
  );
};

// Widget metadata
ShellyWidget.widgetId = 'shelly';
ShellyWidget.title = '🌡️ Datacenter Temp';
ShellyWidget.defaultSize = { cols: 4 };
ShellyWidget.category = 'infrastructure';

export default ShellyWidget;